export const RegExp = {
	MOBILE: /^[1-9]\d{1,14}$/,
	EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i,
	NAME: /^[a-zA-Zа-яА-Я ,.'-]+$/i,
	NUM: /^\d+$/
};
